/**
 * @generated SignedSource<<d9953d979fe9c772511e1be39e72079d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JiraAssignee_whoami$data = {
  readonly whoami: {
    readonly email: string | null | undefined;
  };
  readonly " $fragmentType": "JiraAssignee_whoami";
};
export type JiraAssignee_whoami$key = {
  readonly " $data"?: JiraAssignee_whoami$data;
  readonly " $fragmentSpreads": FragmentRefs<"JiraAssignee_whoami">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JiraAssignee_whoami",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CurrentUser",
      "kind": "LinkedField",
      "name": "whoami",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "b3692f57715e9b6e4c1fdb179bee9fb9";

export default node;
